import { useSearchParams, useLocation } from 'react-router-dom';
import { useCallback, useState } from 'react';

export default function useQueryString(boardTypeCode) {
    
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    /* board */
    const defaultStartDay = new Date((new Date()).getTime() + 1000 * 60 * 60 * 9 - 1000 * 60 * 60 * 24 * 90).toISOString().split('T')[0];
    const defaultEndDay = new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0];
    const defaultLoca = localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emogloca') : 'all';

    // URL → 값 직접 가져오기 (상태 중복 제거)
    const boardSearchObj = {
        // 전체 공통
        searchContent: searchParams.get('searchContent') ?? 'title',
        searchText: searchParams.get('searchText') ?? '',
        searchBoardContent: searchParams.get('searchBoardContent') ?? 'all',
        // 업무공유
        searchStrStartday: searchParams.get('searchStrStartday') ?? defaultStartDay,
        searchStrEndday: searchParams.get('searchStrEndday') ?? defaultEndDay,
        searchLoca: searchParams.get('searchLoca') ?? defaultLoca,
        searchNtc: searchParams.get('searchNtc') ?? '',
    };
    const pageNo = Number(searchParams.get('page')) || 1;
    
    const [boardContents, setBoardContents] = useState('');

    const setBoardParams = useCallback((newValues) => {
        
        const newParams = new URLSearchParams(searchParams);

        Object.entries(newValues).forEach(([key, value]) => {
            if (value === null || value === '' || value === undefined) {
                newParams.delete(key);
            } else {
                newParams.set(key, String(value));
            }
        });
        
        // 업무공유 외 게시판에는 필요없는 쿼리 삭제
        if(boardTypeCode !== 14) {
            ['searchStrStartday', 'searchStrEndday', 'searchLoca', 'searchNtc', 'searchBoardContent'].forEach(k => newParams.delete(k));
        };

        if(!newParams.get('searchText')) {
            newParams.delete('searchContent');
        };
        
        setSearchParams(newParams, { state: location.state });
    }, [searchParams, setSearchParams, boardTypeCode, location.state]);

    /* OrgParticipate */
    const orgSearchObj = {
        searchEmog: searchParams.get('searchEmog') ?? '',
        searchLoca: searchParams.get('searchLoca') ?? '',
        searchType: searchParams.get('searchType') ?? '',
        searchCheck1: searchParams.get('searchCheck1') ?? '',
        searchCheck2: searchParams.get('searchCheck2') ?? '',
    };
    
    const itemsPerPage = Number(searchParams.get('itemsPerPage')) || 10;

    const setOrgParams = useCallback((newValues) => {
        
        const newParams = new URLSearchParams(searchParams);

        Object.entries(newValues).forEach(([key, value]) => {
            if (value === null || value === '' || value === undefined) {
                newParams.delete(key);
            } else {
                newParams.set(key, String(value));
            }
        });
        
        setSearchParams(newParams, { state: location.state });
    }, [searchParams, setSearchParams, location.state]);

    return {
        boardSearchObj,
        pageNo,
        itemsPerPage,
        boardContents,
        setBoardContents,
        setBoardParams,
        orgSearchObj,
        setOrgParams,
        searchParamsStr: searchParams.toString() // 뒤로가기 감지용 쿼리스트링
    };
}